angular
  .module 'memberPortal'
  .controller 'PerformedWorkoutsCtrl', (
    $scope,
    $stateParams,
    WorkoutService,
    UnitSymbols,
    Restangular,
  ) ->
    $scope.workouts = []
    $scope.isLoading = true
    $scope.page = 1

    $scope.getPersonalBest = (exercise) ->
      WorkoutService.getPersonalBest(exercise.personal_best)

    $scope.displayTime = (ex) ->
      moment().startOf('day')
        .hours(ex.actual_hours || 0).minutes(ex.actual_minutes || 0)
        .seconds(ex.actual_seconds || 0).format('HH:mm:ss')

    $scope.displayWeight = (ex) ->
      parseFloat(ex.actual_weight) + UnitSymbols[ex.actual_weight_unit]

    $scope.getHash = ->
      $stateParams.hash || $stateParams.m

    $scope.loadMore = ->
      return if $scope.isLoading || $scope.workouts.length >= $scope.total
      $scope.page = $scope.page + 1
      loadWorkouts()

    loadWorkouts = ->
      $scope.isLoading = true
      Restangular.all('performed_workouts').getList(count: 10, page: $scope.page).then (workouts) ->
        $scope.total = workouts.meta.total
        $scope.isLoading = false
        $scope.workouts = $scope.workouts.concat(workouts.plain())

    loadWorkouts()
